import { guidelineList } from "./guidelines.js";
import { popularTopics } from "./popularTopics.js";
import { isNullOrEmpty } from "./isNullOrEmpty.js";


const PREVIEW_GUIDELINE_FLAGS = {
  sleepdisorder: "sleep_disorder_guideline_enabled",
}; // remove guideline for here when release it

export const getGuidelineList = (includeQuicklinks = false) => {
  let filteredList = guidelineList;

  filteredList = filteredList.filter((item) => {
    const flagKey = PREVIEW_GUIDELINE_FLAGS[item.iconClassSuffix];
    if (flagKey) {
      return sessionStorage.getItem(flagKey) === "true";
    }
    return true;
  });

  if (!includeQuicklinks) {
    filteredList = filteredList.filter((item) => item.iconClassSuffix !== "quicklinks");
  }

  return filteredList;
};

export const getPopularTopics = (guidelineName) => {
  const result = popularTopics.find((item) => {
    return item.onClickProps.toLowerCase() === guidelineName.toLowerCase();
  });

  if (result) {
    return getLimitPopularTopics(result.popularTopics);
  }
};

export const getRandomPopularTopics = (topicCount) => {
  const topics = [];
  for (let count = 0; count < topicCount; count++) {
    const topic = popularTopics[Math.floor(Math.random() * popularTopics.length)].popularTopics;
    topics.push(topic[Math.floor(Math.random() * topic.length)]);
  }
  return topics;
};

// From a list of popular topics, randomly pick up 5 if the length greater than 5
function getLimitPopularTopics(list) {
  if (isNullOrEmpty(list)) return [];
  if (list.length <= 5) return list;

  const shuffled = [...list];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }

  return shuffled.slice(0, 5);
}